exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__topCards___32ViW{display:grid;gap:1em}@media (min-width:768px){.index-module__topCards___32ViW{grid-template-columns:1fr 1fr}}@media (min-width:1325px){.index-module__topCards___32ViW{grid-template-columns:repeat(12,1fr)}}", ""]);

// exports
exports.locals = {
	"topCards": "index-module__topCards___32ViW"
};